export default "__VITE_PUBLIC_ASSET__10da1dfe__"